import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=2f592e2d&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f592e2d",
  null
  
)

export default component.exports